export default function escListener(callback) {
  var listener = (e) => {
    if (e.keyCode === 27) {
      callback();
    }
  }

  window.addEventListener('keydown', listener, false);

  return function removeEscListener() {
    window.removeEventListener('keydown', listener, false);
  }
}



// WEBPACK FOOTER //
// ./src/eventListeners/escListener.js